import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { StatesArray } from '../../global/constants';

import { BlueSwipeCustomerBillingFormSchema } from './validation';
import { fetchPaymentBilling } from '../actions';
import { buildDropdown, getClassNames } from './edit-bankaccount-billing-component';

const mapStateToProps = state => ({
  dashboard: state.Dashboard
});

const cssFormControlError = "form-control error-input";
const cssFormControl = "form-control";

class CreditCardBillingForm extends Component {
  constructor(props) {
    super(props);

    this.state = { errors: null, hasSubmitted: false, resetForm: null }
    this.getInitialValues = this.getInitialValues.bind(this);
    this.shouldResetForm = this.shouldResetForm.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.shouldResetForm(prevProps) && this.state.resetForm) {
      let resetForm = this.state.resetForm;
      resetForm();
      this.setState({ resetForm: null });
    }
  }

  getInitialValues = () => {
    const user = this.props.dashboard.user;
    if (!user)
      return null;

    return user.creditCardBilling;
  }

  shouldResetForm = (prevProps) => {
    const updatedAddress = this.props.dashboard.user.creditCardBilling;
    const oldAddress = prevProps.dashboard.user.creditCardBilling;

    return JSON.stringify(updatedAddress) !== JSON.stringify(oldAddress);
  }

  onSubmit(values, form) {
    let { onSubmit } = this.props;
    this.setState({ hasSubmitted: true, resetForm: form.resetForm });
    onSubmit(values, form);
  }

  renderCityState(isMobile, errors, touched) {
    const cityClass = (errors.address && touched.address && errors.address.city && touched.address.city) ? cssFormControlError : cssFormControl
    return isMobile
      //Mobile View
      ? (<div>
        <div className="fieldgroup fieldgroup-required">
          <Field
            name="address.city" type="text" placeholder="City" className={cityClass}
          />
          <ErrorMessage
            name="address.city" component="div" className="error-message"
          />
        </div>
        <div className="fieldgroup fieldgroup-required">
          {
            buildDropdown("address.state",
              StatesArray, "State", "State",
              (errors.address && touched.address && errors.address.state && touched.address.state)
            )
          }
          <ErrorMessage
            name="address.state" component="div" className="error-message"
          />
        </div>
      </div>
      )
      //Desktop View
      : (
        <div className="fieldgroup row">
          <div className="col-8 pl-0 fieldgroup-required">
            <Field
              name="address.city" type="text" placeholder="City"
              className={cityClass}
            />
          </div>
          <div className="col-4 pr-0 fieldgroup-required fieldgroup-select">
            {
              buildDropdown("address.state",
                StatesArray, "State", "State", (errors.address && touched.address && errors.address.state && touched.address.state)
              )
            }
          </div>
          {
            (errors.address && touched.address
              && ((errors.address.city && touched.address.city) || (errors.address.state && touched.address.state)))
            && (<div className="error-message">This field is required</div>)
          }
        </div>)
  }

  render() {
    let { errorMessage, isMobile } = this.props;
    let { hasSubmitted } = this.state;
    const initialValues = this.getInitialValues();

    if (!initialValues)
      return (<div className="mb-3">Loading Billing Information...</div>);

    return (
      <Formik
        validationSchema={BlueSwipeCustomerBillingFormSchema}
        initialValues={initialValues}
        validateOnBlur={true}
        enableReinitialize={true}
        onSubmit={this.onSubmit}>
        {({ errors, touched, isSubmitting, dirty }) => {
          const classNames = getClassNames(errors, touched);
          return (
            <Form>
              <div className="mb-3">
                <h5>Billing Address</h5>
                <div><i className="fas fa-asterisk required-asterisk"></i> Indicates required field</div>
                <div>
                  <div className="fieldgroup fieldgroup-required">
                    <Field
                      name="firstName"
                      type="text"
                      placeholder="First Name"
                      className={classNames.firstNameClass}
                    />
                    <ErrorMessage name="firstName" component="div" className="error-message" />
                  </div>
                  <div className="fieldgroup fieldgroup-required">
                    <Field
                      name="lastName"
                      type="text"
                      placeholder="Last Name"
                      className={classNames.lastNameClass}
                    />
                    <ErrorMessage name="lastName" component="div" className="error-message" />
                  </div>
                  <div className="fieldgroup fieldgroup-required">
                    <Field
                      name="address.address1"
                      type="text"
                      placeholder="Address Line 1"
                      className={classNames.addressClass}
                    />
                    <ErrorMessage name="address.address1" component="div" className="error-message" />
                  </div>
                  <div className="fieldgroup">
                    <Field
                      name="address.address2"
                      type="text"
                      placeholder="Address Line 2 (Optional)"
                      className={classNames.addressClass2}
                    />
                  </div>
                  {this.renderCityState(isMobile, errors, touched)}
                  <div className="fieldgroup fieldgroup-required">
                    <Field
                      name="address.zip"
                      type="text"
                      pattern="[0-9]*"
                      placeholder="Zip Code"
                      className={classNames.zipClass}
                    />
                    <ErrorMessage name="address.zip" component="div" className="error-message" />
                  </div>
                </div>
                <div>
                  {errorMessage && (<div className="error-message mb-3">{errorMessage.message}</div>)}
                  {!dirty && !errorMessage && Object.keys(touched).length === 0 && hasSubmitted && (<div className="error-message mb-3">Changes saved</div>)}
                  <div className={`button-row row`}>
                    <div className="col">
                      <button className="btn btn-primary" disabled={isSubmitting} type="submit">{isSubmitting ? 'Verifying...' : 'Update'}</button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )
        }}
      </Formik>
    )
  }
}

export default connect(mapStateToProps)(CreditCardBillingForm);
